export default __webpack_public_path__ + "static/Swiss721BT-Light-5fdcb3f53888caa5b171527668c38bd0.woff2";